module.exports = __webpack_public_path__ + "static/media/covid19-popup-zh-CN-mobile.5627d6af.png";